import React, {useMemo} from 'react';

export default <T, >(importStatement: Promise<{ default: React.ComponentType<T> }>) => {
  return useMemo(() => React.lazy(() => importStatement) ,[]);
}
